import { render, staticRenderFns } from "./MapLegendShow.vue?vue&type=template&id=5a0fd238&scoped=true&"
import script from "./MapLegendShow.vue?vue&type=script&lang=js&"
export * from "./MapLegendShow.vue?vue&type=script&lang=js&"
import style0 from "./MapLegendShow.vue?vue&type=style&index=0&id=5a0fd238&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fd238",
  null
  
)

export default component.exports